/**
 * GenericEventContent - Fallback renderer for timeline events without a specific content component
 * Shows event description and actor
 */

import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface GenericEventContentProps {
  event: TimelineEvent;
}

const GenericEventContent: React.FC<GenericEventContentProps> = ({ event }) => {
  const { t } = useTranslation();

  return (
    <div className="sphere-timeline-event__content-block">
      <p className="sphere-timeline-event__description">
        {t(`timeline.eventDescriptions.${event.eventType}`, {
          lifecycleStage: event.payload?.lifecycleStage || '',
        })}
      </p>

      {event.actor && (
        <div className="sphere-timeline-event__meta-row">
          <i className="pi pi-user" />
          <span className="sphere-timeline-event__meta-label">
            {t('timeline.eventDetails.actor')}
          </span>
          <span className="sphere-timeline-event__meta-value">{event.actor}</span>
        </div>
      )}
    </div>
  );
};

export default GenericEventContent;
